import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9df8bb14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-featured-links" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "layout-featured-links__grid" }
const _hoisted_4 = ["href", "target"]
const _hoisted_5 = {
  key: 0,
  class: "featured-link__image-wrapper"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "featured-link__icon"
}
const _hoisted_8 = { class: "featured-link__content" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "featured-link__arrow" }

import ChevronRightIcon from '@/components/icons/ChevronRightIcon.vue';
import FileCheckIcon from '@/components/icons/FileCheckIcon.vue';
import FileSymlinkIcon from '@/components/icons/FileSymlinkIcon.vue';
import PenToolIcon from '@/components/icons/PenToolIcon.vue';
import RefreshCcwDotIcon from '@/components/icons/RefreshCcwDotIcon.vue';
import { computed } from 'vue';

interface FeaturedLink {
	featured_link_title: string;
	featured_link_subtitle?: string;
	featured_link_link?: {
		url: string;
		title: string;
		target: string;
	};
	featured_link_is_blue: boolean;
	featured_link_use_custom_image: boolean;
	featured_link_icon?: string;
	featured_link_image?: {
		url: string;
		alt: string;
	};
}

interface Props {
	title: string;
	featuredLinks: FeaturedLink[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentFeaturedLinks',
  props: {
    title: {},
    featuredLinks: {}
  },
  setup(__props: any) {

const props = __props;

const filteredFeaturedLinks = computed(() => {
	return props.featuredLinks.filter(link => link.featured_link_link?.url);
});

const getIconComponent = (iconName: string) => {
	switch (iconName) {
		case 'file-check':
			return FileCheckIcon;
		case 'file-symlink':
			return FileSymlinkIcon;
		case 'pen-tool':
			return PenToolIcon;
		case 'refresh-ccw-dot':
			return RefreshCcwDotIcon;
		default:
			return null;
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h3", {
          key: 0,
          class: "layout-featured-links__title",
          innerHTML: _ctx.title
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFeaturedLinks.value, (link, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          href: link.featured_link_link.url,
          target: link.featured_link_link.target || '_self',
          class: _normalizeClass(["featured-link", {
					'featured-link--blue': link.featured_link_is_blue,
					'featured-link--white': !link.featured_link_is_blue
				}])
        }, [
          (link.featured_link_use_custom_image && link.featured_link_image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: link.featured_link_image.url,
                  alt: link.featured_link_image.alt,
                  class: "featured-link__image"
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          (!link.featured_link_use_custom_image && link.featured_link_icon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["featured-link__svg-circle", {
							'featured-link__svg-circle--blue': link.featured_link_is_blue,
							'featured-link__svg-circle--white': !link.featured_link_is_blue
						}])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(getIconComponent(link.featured_link_icon)), { class: "featured-link__svg" }))
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "featured-link__title",
              innerHTML: link.featured_link_title
            }, null, 8, _hoisted_9),
            (link.featured_link_subtitle)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "featured-link__subtitle",
                  innerHTML: link.featured_link_subtitle
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(ChevronRightIcon)
          ])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})